export default __webpack_public_path__ + "static/media/selected_circle.9077c015.svg";